import { NgModule } from '@angular/core';
import { QuestionnaireApiService } from '@gelato-api-ui/core/quick-questions/services/questionnaire-api.service';

@NgModule({
  providers: [QuestionnaireApiService],
})
export class QuickQuestionsModule {}
